import React from 'react';

function Button({ onClick, label }) {
  return (
    <div className="font-poppins space-x-4 space-y-4 text-center mt-10 md:mb-5">
      <button
        onClick={onClick} // onclick pass as a props
        type="button"
        className="text-xs md:text-md ml-6 px-4 py-2 md:px-5 md:py-2.5 rounded-lg font-normal font-poppins tracking-wider curser-pointer transition-all duration-300"
        style={{
          backgroundColor: 'var(--btn-selected-color)',
          color: '#202020',
        }}
        onMouseEnter={(e) =>
          (e.target.style.backgroundColor = 'var(--btn-hover-color)')
        } // Change to hover color
        onMouseLeave={(e) =>
          (e.target.style.backgroundColor = 'var(--btn-selected-color)')
        } // Revert to original color
      >
        {label}
      </button>
    </div>
  );
}

export default Button;
